export default "__VITE_PUBLIC_ASSET__071d82c1__"